import { flattenClassNames } from '@trukt/portal-utils/flattenClassNames';
import { Badge } from '../Badge/Badge';
import { Typography } from '../Typography';

export interface StatusPillProps<T extends string = string> {
  status: T;
  count?: string;
  bgColorClassName?: string;
}

export const StatusPill = <T extends string = string>({
  status,
  count,
  bgColorClassName,
}: StatusPillProps<T>) => {
  return (
    <div>
      <Badge
        position="top-right"
        value={count}
        isVisible={Boolean(count)}
        right="right-[-0.35rem]"
        top="top-[-0.5rem]"
      >
        <div
          className={flattenClassNames([
            'flex h-[1.5rem] items-center justify-center rounded-md p-2',
            bgColorClassName ?? 'bg-bg-primary',
          ])}
        >
          <Typography className="font-700 !text-common-white uppercase">{status}</Typography>
        </div>
      </Badge>
    </div>
  );
};
